import React from 'react';

export const Line: React.FC = () => <div className="c-line"></div>;

export const RowLine: React.FC = () => (
  <div className="l-row">
    <Line />
  </div>
);
